/**
 * MMP Metadata
 * This is a API for MMP Metadata
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: st116848@stud.uni-stuttgart.de.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { Workflow } from '../model/workflow';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class WorkflowService {

    protected basePath = 'https://localhost:8080/v1/metadata';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    /**
     * one specific workflow
     * Return one workflow
     * @param run The run\&#39;s id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWorkflowByRun(run: string, observe?: 'body', reportProgress?: boolean): Observable<Workflow>;
    public getWorkflowByRun(run: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Workflow>>;
    public getWorkflowByRun(run: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Workflow>>;
    public getWorkflowByRun(run: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (run === null || run === undefined) {
            throw new Error('Required parameter run was null or undefined when calling getWorkflowByRun.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Workflow>(`${this.configuration.basePath}/experiments/run/${encodeURIComponent(String(run))}/workflow`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
